function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h50v50H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#371447",
  d: "M1.879 12.889v3.091l22.626 6.681 22.897-6.681v-1.705"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.817 13.088l.55-.836c.097-.016 7.291-1.573 21.58-4.674l23.118 5.449.359 1.436",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.508 10.756L15.62 16.78c-.412.112-.69.254-.834.423-.145.17-.248.477-.31.92v25.305l-4.06-1.163V16.9c.065-.43.17-.805.318-1.126.147-.321.637-.596 1.469-.825l19.545-5.156 3.76.964z",
  fill: "#FB8C00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.337 10.686l19.888 6.024c.412.113.69.254.834.423.145.17.248.477.31.921v25.304l4.16-1.4V16.593a4.178 4.178 0 00-.317-1.127c-.148-.321-.637-.596-1.469-.825L17.198 9.485l-3.86 1.201z",
  fill: "#FB8C00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.44 16.74v23.177l21.031 6.059 21.044-6.059V16.74L24.477 22.8 3.44 16.74z",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.123 12.894c.11-1.672.736-3.5 1.875-5.483 1.14-1.983 2.305-3.273 3.497-3.87 7.695 4.067 11.823 6.653 12.384 7.758.56 1.105.687 1.622.378 1.55-.497.627-.763.938-.798.933-3.418-.503-6.124-.668-8.118-.788-2.024-.122-5.097-.156-9.218-.1z",
  fill: "#FB8C00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.855 12.894c-.112-1.672-.737-3.5-1.876-5.483-1.139-1.983-2.304-3.273-3.497-3.87C28.788 7.609 24.66 10.195 24.1 11.3c-.561 1.105-.541 1.772.059 1.999.205.327.325.489.36.484 3.419-.503 6.125-.668 8.118-.788 2.024-.122 5.097-.156 9.219-.1z",
  fill: "#FB8C00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.473 13.75L21.4 10.47c.582-.238 1.533-.352 2.853-.342 1.32.01 2.204.138 2.65.383l-1.202 3.24c-.256.2-.745.3-1.47.3-.723 0-1.31-.1-1.758-.3z",
  fill: "#FB8C00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.583 45.87V25.636v20.236z",
  stroke: "#371447"
}));

function SvgOccasionsMd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgOccasionsMd;